// extracted by mini-css-extract-plugin
export default {"table":"LinkedAccountsTable_table__bajFC","bold":"LinkedAccountsTable_bold__vuqAO","none":"LinkedAccountsTable_none__9p+Jv"};